import { createContext, useContext, useState } from 'react';

import type { ReactFCWithChildren } from '@widget/types/ReactFCWithChildren';

export type CloseWidgetContextType = {
  isOpenModal: boolean;
  isThankYouPageShown: boolean;
  setIsOpenModal: (isOpen: boolean) => void;
  setIsThankYouPageShown: (isOpen: boolean) => void;
};

const CloseWidgetContext = createContext<CloseWidgetContextType | null>(null);

export const CloseWidgetProvider: ReactFCWithChildren<any> = ({ children }) => {
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [isThankYouPageShown, setIsThankYouPageShown] = useState(false);
  return (
    <CloseWidgetContext.Provider
      value={{ isOpenModal, setIsOpenModal, isThankYouPageShown, setIsThankYouPageShown }}
    >
      {children}
    </CloseWidgetContext.Provider>
  );
};

export const useCloseWidget = (): CloseWidgetContextType => {
  const closeWidgetContext = useContext(CloseWidgetContext);

  if (closeWidgetContext === null) {
    throw new Error('The useCloseWidget hook must be used within the closeWidgetContext provider');
  }

  return closeWidgetContext;
};
